import React, { useState, useEffect, useRef } from "react"
import { Link } from "gatsby"
import { navigate } from "gatsby/"
import { connect } from "react-redux"
import { motion, AnimatePresence } from "framer-motion"

import AccordionIcon from "./accordionIcon"

import arrow_right from "../../images/icon/arrow-right.svg"
// hooks
import useDrawer from '../../hooks/useDrawer';



const Accordion = ({
  id,
  title,
  cart = false,
  isNew = false,
  link = false,
  to = null,
  nested = false,
  lastChild = false,
  isOpen = false,
  cb = null,
  containerRef,
  children,
  slug,
}) => {


  const accordionRef = useRef()
  const [expanded, setExpanded] = useState(false)
  const isLink = link && to

  //
  const { 
    currentDrawer,
    changeDrawer
  } = useDrawer()


  const handleLinkClick = e => {
    e.preventDefault()
    navigate(to)
  }


  const openDrawer = () => {
    setExpanded(true)
  }

  const closeDrawer = () => {
    setExpanded(false)
  }


useEffect(() => {
/*
    const searchParams = new URLSearchParams(window.location.search)
    const openAccordions = [...searchParams.keys()];

    const shouldOpen = openAccordions.includes(slug);
*/


   // const isFirst = openAccordions[0] == slug;
    const isCurrentDrawer = slug === currentDrawer;

    if(isCurrentDrawer) {
      openDrawer()
    } else {
      closeDrawer()
    }

    if (isCurrentDrawer /*&& isFirst */&& !!containerRef) {
      containerRef.current.scroll({
        top: accordionRef.current.offsetTop,
        left: 0,
        behavior: 'smooth'
      });
    }

}, [currentDrawer, isOpen])




  return (
    <div
      id={`#${slug}`}
      ref={accordionRef}
      key={id}
      className={`accordion ${nested ? "nested" : ""} ${
        link ? "accordion--link" : ""
      } ${cart ? "accordion--cart" : ""}`}
    >
      <motion.button
        initial={false}
        onClick={e => {
          if (isLink && to !== null) {
            handleLinkClick(e)
          } else {

            setExpanded(!expanded)

            changeDrawer(slug)

            if (typeof cb === "function") {
              cb()
            }
          }
        }}
        aria-expanded={expanded}
        className={`accordion--toggle${expanded ? " is-open" : ""} ${
          lastChild ? "lastChild" : ""
        }`}
      >
        <div className="accordion-titles">
          {isLink ? (
            <Link to={to} title={title}>
              <h1 id="id">{id}</h1>
              <h1 id="title" className={`title-${id}`}>
                {title}
              </h1>
              {isNew && <span className="new">New!</span>}
            </Link>
          ) : (
            <React.Fragment>
              <h1 id="id">{id}</h1>
              <h1 id="title" className={`title-${id}`}>
                {title}
              </h1>
            </React.Fragment>
          )}
        </div>

        <div className="accordion--icon">
          {isLink ? <img src={arrow_right} alt={title} /> : <AccordionIcon />}
        </div>
      </motion.button>
      <AnimatePresence initial={false}>
        {expanded && (
          <motion.section
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { opacity: 1, height: "auto" },
              collapsed: { opacity: 0, height: 0 },
            }}
            transition={{ duration: 0.5, ease: [0.19, 1.0, 0.22, 1.0] }}
            className="accordion--content"
          >
            <div className="accordion--inner">{children}</div>
          </motion.section>
        )}
      </AnimatePresence>
    </div>
  )
}

export default connect(
  state => ({
    mainDrawer: state.global.mainDrawer,
  }),
  null
)(Accordion)
